import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalenderRemove"><Path d="M8.5 2H7V4H3V21H12V19.5H4.5V10H19.5V12H21V4H17V2H15.5V4H8.5V2Z" fill="currentColor"/><Path d="M15.7482 14.6893L14.6875 15.75L16.9375 18L14.6875 20.25L15.7482 21.3107L17.9982 19.0607L20.2482 21.3107L21.3088 20.25L19.0588 18L21.3088 15.75L20.2482 14.6893L17.9982 16.9393L15.7482 14.6893Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderRemove;
